import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
const REIKI_SYMBOLS = ['M12 2v16c0 2 2 3 4 3s4-1 4-3-2-3-4-3-4 1-4 3c0 1 .5 2 1.5 2.5M12 6c-3 0-5 2-5 4s2 4 5 4 5-2 5-4-2-4-5-4z', 'M7 4c0 4 2 6 5 6s5-2 5-6M12 10v10M9 14h6M5 8h14', 'M12 3v18M8 7h8M7 11h10M9 15h6M10 19h4', 'M12 2L4 10h16L12 2zM12 10v12M8 14h8M6 18h12'];
const LavenderSVG = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 120 350" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-80">
    <path d="M60 350 Q70 200 30 30" stroke="#8B9D77" strokeWidth="2.5" strokeLinecap="round" data-id="element-81" />
    <path d="M63 300 Q85 280 90 250 Q70 270 61 290" fill="#8B9D77" opacity="0.7" data-id="element-82" />
    <path d="M57 250 Q35 230 30 200 Q50 220 59 240" fill="#8B9D77" opacity="0.7" data-id="element-83" />
    <path d="M65 180 Q85 160 90 130 Q70 150 63 170" fill="#8B9D77" opacity="0.7" data-id="element-84" />
    <g opacity="0.85" data-id="element-85">
      <ellipse cx="45" cy="140" rx="4" ry="6" fill="#a78bfa" transform="rotate(20 45 140)" data-id="element-86" />
      <ellipse cx="52" cy="135" rx="3" ry="5" fill="#c084fc" transform="rotate(-15 52 135)" data-id="element-87" />
      <ellipse cx="55" cy="120" rx="4.5" ry="7" fill="#c084fc" transform="rotate(-25 55 120)" data-id="element-88" />
      <ellipse cx="48" cy="115" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(10 48 115)" data-id="element-89" />
      <ellipse cx="40" cy="100" rx="3.5" ry="6" fill="#d8b4fe" transform="rotate(30 40 100)" data-id="element-90" />
      <ellipse cx="47" cy="95" rx="4" ry="6" fill="#a78bfa" transform="rotate(-10 47 95)" data-id="element-91" />
      <ellipse cx="50" cy="80" rx="5" ry="8" fill="#a78bfa" transform="rotate(-20 50 80)" data-id="element-92" />
      <ellipse cx="42" cy="75" rx="3" ry="5" fill="#c084fc" transform="rotate(15 42 75)" data-id="element-93" />
      <ellipse cx="35" cy="60" rx="4" ry="6" fill="#c084fc" transform="rotate(25 35 60)" data-id="element-94" />
      <ellipse cx="42" cy="55" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(-5 42 55)" data-id="element-95" />
      <ellipse cx="45" cy="40" rx="4.5" ry="7" fill="#a78bfa" transform="rotate(-30 45 40)" data-id="element-96" />
      <ellipse cx="38" cy="35" rx="3" ry="5" fill="#c084fc" transform="rotate(10 38 35)" data-id="element-97" />
      <ellipse cx="30" cy="25" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(20 30 25)" data-id="element-98" />
      <ellipse cx="35" cy="20" rx="2.5" ry="4" fill="#a78bfa" transform="rotate(-15 35 20)" data-id="element-99" />
    </g>
  </svg>;
export function HeroAmbientEffects() {
  const particles = useMemo(() => {
    return Array.from({
      length: 40
    }).map((_, i) => ({
      id: `particle-${i}`,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      size: Math.random() * 4 + 2,
      duration: Math.random() * 20 + 15,
      delay: Math.random() * 10,
      opacity: Math.random() * 0.08 + 0.02,
      color: Math.random() > 0.5 ? '#D4AF37' : '#a78bfa'
    }));
  }, []);
  const symbols = useMemo(() => {
    return Array.from({
      length: 12
    }).map((_, i) => ({
      id: `symbol-${i}`,
      path: REIKI_SYMBOLS[i % REIKI_SYMBOLS.length],
      left: `${Math.random() * 90 + 5}%`,
      top: `${Math.random() * 90 + 5}%`,
      size: Math.random() * 80 + 40,
      duration: Math.random() * 25 + 20,
      delay: Math.random() * 10,
      opacity: Math.random() * 0.04 + 0.01
    }));
  }, []);
  return <div className="absolute inset-0 pointer-events-none overflow-hidden z-10" data-id="element-100">
      {/* Crystal Light Shimmer */}
      <motion.div animate={{
      opacity: [0.02, 0.06, 0.02],
      scale: [1, 1.05, 1]
    }} transition={{
      duration: 15,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white/10 via-transparent to-transparent" data-id="element-101" />

      {/* Faint Transparent Reiki Symbols */}
      {symbols.map(symbol => <motion.svg key={symbol.id} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round" className="text-white absolute" style={{
      left: symbol.left,
      top: symbol.top,
      width: symbol.size,
      height: symbol.size,
      opacity: symbol.opacity
    }} animate={{
      y: [0, -30, 0],
      x: [0, 15, 0],
      rotate: [0, 5, -5, 0],
      opacity: [symbol.opacity * 0.5, symbol.opacity, symbol.opacity * 0.5]
    }} transition={{
      duration: symbol.duration,
      repeat: Infinity,
      delay: symbol.delay,
      ease: 'easeInOut'
    }} data-id="element-102">
          <path d={symbol.path} data-id="element-103" />
        </motion.svg>)}

      {/* Floating Particles */}
      {particles.map(p => <motion.div key={p.id} className="absolute rounded-full" style={{
      left: p.left,
      top: p.top,
      width: p.size,
      height: p.size,
      backgroundColor: p.color,
      opacity: p.opacity,
      boxShadow: `0 0 ${p.size * 2}px ${p.color}`
    }} animate={{
      y: [0, -150],
      x: [0, Math.random() * 50 - 25],
      opacity: [0, p.opacity, 0]
    }} transition={{
      duration: p.duration,
      repeat: Infinity,
      delay: p.delay,
      ease: 'easeInOut'
    }} data-id="element-104" />)}

      {/* Delicate Lavender Branches */}
      <motion.div className="absolute top-[5%] -left-10 w-40 opacity-[0.08] blur-[1px]" animate={{
      rotate: [-1, 2, -1]
    }} transition={{
      duration: 14,
      repeat: Infinity,
      ease: 'easeInOut'
    }} style={{
      transformOrigin: 'bottom center'
    }} data-id="element-105">
        <LavenderSVG className="w-full h-auto" data-id="element-106" />
      </motion.div>

      <motion.div className="absolute top-[35%] -right-12 w-48 opacity-[0.06] blur-[2px] scale-x-[-1]" animate={{
      rotate: [1, -2, 1]
    }} transition={{
      duration: 18,
      repeat: Infinity,
      ease: 'easeInOut'
    }} style={{
      transformOrigin: 'bottom center'
    }} data-id="element-107">
        <LavenderSVG className="w-full h-auto" data-id="element-108" />
      </motion.div>

      <motion.div className="absolute bottom-[15%] -left-16 w-56 opacity-[0.07] blur-[1.5px]" animate={{
      rotate: [-2, 1, -2]
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'easeInOut'
    }} style={{
      transformOrigin: 'bottom center'
    }} data-id="element-109">
        <LavenderSVG className="w-full h-auto" data-id="element-110" />
      </motion.div>
    </div>;
}